function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { useEffect, useState } from 'react';
import { canUseDOM } from '../../../utils';
import { throttle } from 'lodash';
import { useModal } from '../Modal/useModal';
const emptyModalVideo = {
  src: '',
  type: '',
  title: '',
  playing: false,
  loading: true,
  visiblePlayButton: true
};
export function useVideoModal() {
  const [modalVideoState, setModalVideoState] = useState(emptyModalVideo);
  const [startOnce, setStartOnce] = useState(true);
  const {
    isShown,
    toggle
  } = useModal();
  let checkMouseMoved;
  if (canUseDOM) {
    checkMouseMoved = throttle(() => {
      if (!modalVideoState.visiblePlayButton) {
        setModalVideoState(_objectSpread(_objectSpread({}, modalVideoState), {}, {
          visiblePlayButton: true
        }));
      }
    }, 300);
  }
  useEffect(() => {
    if (modalVideoState.type === 'media') {
      let timer;
      if (modalVideoState.visiblePlayButton) {
        timer = setTimeout(() => {
          setModalVideoState(_objectSpread(_objectSpread({}, modalVideoState), {}, {
            visiblePlayButton: false
          }));
        }, 2000);
      }
      return () => {
        clearTimeout(timer);
      };
    }
  }, [modalVideoState]);
  console.log('<modalVideoState', modalVideoState);
  useEffect(() => {
    if (!isShown) {
      setStartOnce(true);
    }
  }, [isShown]);
  return {
    modalVideoState,
    setModalVideoState,
    isShown,
    toggle,
    startOnce,
    setStartOnce,
    checkMouseMoved
  };
}